function SensCommunication(sens) {
    switch (sens) {
    case 1:
    case 11:
        return { Icone: 'text-success fas fa-arrow-alt-circle-up', Type: 'Message envoyé' };
    case 2:
    case 12:
        return { Icone: 'text-primary fas fa-arrow-alt-circle-down', Type: 'Message reçu' };
    default:
        return { Icone: 'fas fa-question-circle', Type: 'Sens inconnu' };
    }
}

export default SensCommunication;



// WEBPACK FOOTER //
// ./src/App_Data/SensCommunication.js